import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckoutContactFormService } from '@checkout-v2/feature';
import { PhoneAuthorizedUserDirective, PhoneMaskFixDirective } from '@sdvor/shared/ui';
import { SdvorInputComponent, SdvorTextareaComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { CheckoutValidationErrorComponent } from '../checkout-validation-error';
import { SubmitOrderComponent } from '../submit-order';

@Component({
  selector: 'sd-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SdvorInputComponent,
    SdvorTextareaComponent,
    ReactiveFormsModule,
    PhoneMaskFixDirective,
    PhoneAuthorizedUserDirective,
    SubmitOrderComponent,
    CheckoutValidationErrorComponent,
  ],
})
export class ContactsComponent {
  private readonly checkoutContactForm = inject(CheckoutContactFormService);
  private readonly deviceService = inject(DeviceService);

  protected readonly isDesktopLgUp = toSignal(this.deviceService.isDesktopLgUp$, { initialValue: false });

  protected readonly form = this.checkoutContactForm.getInstance();
}
